import { Rule, RuleContainerSetting } from '@absg/nim-client-shared';

export class RuleContainerSettingGenerator {
  static Generate(positionId: number, value: string, name: string, rule: number, min: string, max: string, defaultValue: string): RuleContainerSetting {
    const ruleContainerSetting = new RuleContainerSetting(
      rule, // rule id
      positionId, // container id
      0, // rule containertype id
      value, // value
      new Rule(
        rule, // rule id
        null, // rule type id
        null, // rule category new RuleCategory(0, 'Properties', 1),
        null, // parent ruletypeid
        1, // display sequence id
        false, // display to user
        name, // name
        null, // description
        'Integer', // data type
        defaultValue, // default value
        4, // max length
        min, // min value
        max, // max value
        true, // required
        '', // message
        '', // pattern
        null, // pattern message
        '', // units
      ));
    return ruleContainerSetting;
  }

}
